import Keycloak from "keycloak-js";
import LocalStorageService from "@services/LocalStorageService";
import { toast } from "react-toastify";
import { route } from "@routes/helper";
import { isStaticPage } from "@selectors/index";
import config from "./config";
const _kc = new Keycloak({
  url: config.keycloakServerUrl,
  realm: "goodshape-central",
  clientId: config.keycloakClient,
});

const initKeycloak = onAuthenticatedCallback => {
  _kc
    .init({
      onLoad: "check-sso",
      silentCheckSsoRedirectUri: route("SILENT_CHECK_SSO_HTML", { domain: window.location.origin }),
    })
    .then(authenticated => {
      if (authenticated || isStaticPage()) {
        onAuthenticatedCallback();
      } else {
        doLogin();
      }
    })
    .catch(e => {
      console.error("Initialize fail", e);
      document.body.innerHTML =
        "<div style='display: flex;height:100vh; align-items:center; justify-content: center;'><h2>Failed to connect, check your internet connection</h2></div>";
      setTimeout(() => {
        location.reload();
      }, 5000);
    });
};

const doLogin = () => {
  LocalStorageService.clearToken();
  _kc.login();
};

const doLogout = () => {
  LocalStorageService.clearToken();
  _kc.logout();
};

const getToken = () => _kc.token;

const isLoggedIn = () => !!_kc.token;

const updateToken = (successCallback, failCallback = null) =>
  _kc
    .updateToken()
    .then(successCallback)
    .catch(() => {
      toast.warning("Your session has timed out and you are being returned to the login screen.");
      setTimeout(doLogin, 5000);
    });

const getUsername = () => (_kc.tokenParsed ? _kc.tokenParsed.preferred_username : "");

const changePassword = () => {
  _kc.login({ action: "UPDATE_PASSWORD" });
};

const keycloak = {
  initKeycloak,
  doLogin,
  doLogout,
  isLoggedIn,
  getToken,
  updateToken,
  getUsername,
  changePassword,
  getInstance: () => _kc,
};

export default keycloak;
